/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PoiBase
 */
export interface PoiBase {
    /**
     * 
     * @type {number}
     * @memberof PoiBase
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PoiBase
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PoiBase
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof PoiBase
     */
    categoryName: string;
    /**
     * 
     * @type {string}
     * @memberof PoiBase
     */
    categoryIcon?: string;
    /**
     * 
     * @type {string}
     * @memberof PoiBase
     */
    geographyName?: string;
    /**
     * 
     * @type {number}
     * @memberof PoiBase
     */
    geoLongitude?: number;
    /**
     * 
     * @type {number}
     * @memberof PoiBase
     */
    geoLatitude?: number;
}

export function PoiBaseFromJSON(json: any): PoiBase {
    return PoiBaseFromJSONTyped(json, false);
}

export function PoiBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PoiBase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'categoryName': json['categoryName'],
        'categoryIcon': !exists(json, 'categoryIcon') ? undefined : json['categoryIcon'],
        'geographyName': !exists(json, 'geographyName') ? undefined : json['geographyName'],
        'geoLongitude': !exists(json, 'geoLongitude') ? undefined : json['geoLongitude'],
        'geoLatitude': !exists(json, 'geoLatitude') ? undefined : json['geoLatitude'],
    };
}

export function PoiBaseToJSON(value?: PoiBase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'address': value.address,
        'categoryName': value.categoryName,
        'categoryIcon': value.categoryIcon,
        'geographyName': value.geographyName,
        'geoLongitude': value.geoLongitude,
        'geoLatitude': value.geoLatitude,
    };
}


